<template id="viztype-screen">
    <section>
        <b-alert
                :show="dismissCountDown"
                dismissible
                variant="Success"
                @dismissed="dismissCountDown=0">
            Record Saved Successfully
        </b-alert>
        <b-alert
                :show="dismissCountDownUpdated"
                dismissible
                variant="Warning"
                @dismissed="dismissCountDown=0">
            Record Updated Successfully
        </b-alert>
        <div class="row">
            <div class="col-md-10 col-lg-12 text-center mt-3 mb-5 ml-2">
                <div class="card">
                    <div class="card-header text-left">
                        <i class="fa fa-searchengin"></i>
                        Viz Type Screen
                    </div>
                    <div class="card-body">
                        <!--Filters-->
                        <!--table-->
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead class="thead-dark">
                                <tr class="text-center">
                                    <th>Viz Type ID</th>
                                    <th>Viz Type Name</th>
                                    <th>Viz Type Function Name</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(x,idx) in vizTypeData" @click="toggle(x.syspk)"
                                          :class="{ opened: opened.includes(x.syspk) }">
                                    <tr :value="x" v-bind:key="idx">
                                        <td>
                                            <span class="color">{{x.vizTypeId}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.vizTypeName}}</span><br>
                                        </td>
                                        <td>
                                            <span class="color">{{x.vizTypeFunctionName}}</span><br>
                                        </td>
                                        <td class="text-center">
                                            <div class="btn-group">
                                                <button class="btn btn-sm btn-outline-primary" v-b-tooltip.hover
                                                        title="Add"
                                                        v-on:click="showRow(x.syspk)">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                                <button class="btn btn-sm btn-outline-warning" size="sm"
                                                        v-b-tooltip.hover
                                                        title="Edit" v-on:click="edit(x.syspk)">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <template v-if="showInputfield && x.syspk == editableId">
                                        <tr :key="x.idx"><h6>Edit Record</h6></tr>
                                        <tr :key="x.idx" style="background-color: #FFF9DF;font-size: 12px">
                                            <td>
                                                <label>Viz Type ID</label>
                                                <input type="text"
                                                       v-model="x.vizTypeId"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>Viz Type Name</label>
                                                <input type="text"
                                                       v-model="x.vizTypeName"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td>
                                                <label>Viz Type Function Name</label>
                                                <input type="text"
                                                       v-model="x.vizTypeFunctionName"
                                                       class="form-control" :disabled="true">
                                            </td>
                                            <td class="text-center">
                                                <button class="btn btn-sm btn-outline-primary"
                                                        v-on:click="updateVizType(x)"
                                                        v-b-tooltip.hover
                                                        title="Save">
                                                    <i class="fa fa-save"></i>
                                                </button>
                                                <button class="btn btn-sm btn-danger" v-on:click="hideR(e,x)"
                                                        v-b-tooltip.hover
                                                        title="Cancel">
                                                    <i class="fa fa-window-minimize"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-if="showInput && x.syspk == savetableId">
                                        <tr :key="x.idx"><h6>New Record</h6></tr>
                                        <tr :key="x.idx" style="background-color: #FFF9DF;font-size: 12px">
                                            <td>
                                                <label>Viz Type id</label>
                                                <input type="text"
                                                       v-model="e.vizTypeId"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>Viz Type Name</label>
                                                <input type="text"
                                                       v-model="e.vizTypeName"
                                                       class="form-control">
                                            </td>
                                            <td>
                                                <label>Viz Type Function Name</label>
                                                <input type="text"
                                                       v-model="e.vizTypeFunctionName"
                                                       class="form-control">
                                            </td>
                                            <td class="text-center">
                                                <b-button v-on:click="saveVizConfig(e)" variant="outline-primary"
                                                          size="sm"
                                                          v-b-tooltip.hover
                                                          title="Save">
                                                    <i class="fa fa-save"></i>
                                                </b-button>
                                                <b-button v-on:click="hideR(e)" variant="outline-danger" size="sm"
                                                          v-b-tooltip.hover
                                                          title="Cancel">
                                                    <i class="fa fa-window-minimize"></i>
                                                </b-button>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'

export default {

        name: 'viztype-screen',
        data: function () {
            return {
                vizTypeData: [],
                e: [],
                showInput: '',
                showInputfield: '',
                options: [],
                editableId: [],
                dismissSecs: 1,
                dismissCountDown: 0,
                dismissCountDownUpdated: 0,
                flag: ['True', 'False'],
                options2: [],
                opened: [],
                savetableId: [],
                hideRow: [],
            }
        },

        created: function () {
            this.loadVizType()
        },
        methods: {
            //Get Request
            loadVizType: function () {
               console.log('vv', 'load state'); this.$store.dispatch("loadState").then(() => {
                    this.vizTypeData = this.$store.state.vizType
                    console.log("ALl fw viz type data", this.vizTypeData)
                }, err => {
                    console.log('Error in fetching Record', err)
                })
            },
            //Post Request
            saveVizConfig: function (e) {
                console.log("Test save record",this.e)
                let payload = Object.assign({}, e)
                axios.post('/api/viztype', payload)
                    .then(this.loadVizType(), e => {
                        console.error('error in Saving Record', e)
                    })
                this.dismissCountDown = this.dismissSecs
                this.savetableId = null
            }
            ,

            //Put/Update Request
            updateVizType: function (x) {
                console.log('Testing update request', this.x)
                axios.put('/api/dashboard_screen/viztype', x)
                    .then(response => {
                        console.log('Data Updated successfully', response)
                    })
                    .then(this.loadVizType(), e => {
                        console.error('error in Updating Record', e)
                    })
                this.dismissCountDownUpdated = this.dismissSecs
                this.editableId = null
            }
            ,

            //Show Edit Input Field
            edit: function (syspk, x) {
                console.log('Entered into edit function', x)
                this.showInputfield = true
                this.editableId = syspk
            }
            ,

            //Show Row
            showRow: function (syspk) {
                this.showInput = true
                this.savetableId = syspk

            }
            ,
            //High Light Selected Row
            toggle(syspk) {
                /* const index = this.opened.indexOf(id)*/
                this.opened.push(syspk)
            }
            ,
            show: function () {
                this.$modal.show('hello-world')
            }
            ,
            hide: function () {
                this.$modal.hide('hello-world')
            }
            ,

            //Hide Add record or save record
            hideR: function (syspk) {
                if (this.savetableId == syspk) {
                    this.savetableId = null
                    this.editableId = null
                } else {
                    this.savetableId = syspk
                    this.editableId = syspk
                }
            }
        },//Method End

    }
</script>
<style>
    .opened {
        background-color: #EBEBEB;
    }

    .t-scroll {
        display: inline-block;
        height: 260px;
        overflow-y: scroll;
    }

    .font {
        /*color: #0b58a2;*/
    }

    .color {
        font-weight: bold;
        color: dimgrey;
    }

    /*Hide up/down arrowin input fields*/
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .table {
        font-size: 12px;
        text-align: left;
    }

    .table tr, .table td {
        height: 3px;
    }

    /*To Increase or Decrease Row Height change the padding value*/
    .table > tbody > tr > td, .table > tbody > tr > th, .table > tfoot > tr > td, .table > tfoot > tr > th, .table > thead > tr > td, .table > thead > tr > th {
        padding: 2px;
    }
</style>




